import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {RouteInfo} from '@app/shared';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  private _breadcrumbSubject = new BehaviorSubject<RouteInfo[]>([]);
  breadcrumb$ = this._breadcrumbSubject.asObservable();

  constructor(private router: Router) { }

  setBreadcrumb(items: RouteInfo[]): void {
    this._breadcrumbSubject.next(items);
  }

  backLevelBreadcrumb(): void {
    // Elimina el último elemento
    this._breadcrumbSubject.value.pop();
    // Si aún quedan elementos, navega hacia la propiedad 'navigate' del último y luego la elimina
    if (this._breadcrumbSubject.value.length > 0) {
      this.router.navigate([this._breadcrumbSubject.value[this._breadcrumbSubject.value.length - 1].navigate]).then(() => {
        delete this._breadcrumbSubject.value[this._breadcrumbSubject.value.length - 1].navigate;
      });
    }
  }
}
